
jQuery(function() {
  var $module = jQuery('#m-1590679002094').children('.module');
  $module.gfV3Product();
});jQuery(function() {
    var $module = jQuery('#m-1590679004720').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});jQuery(function() {
  var $module = jQuery('#m-1590679004401').children('.module');
  $module.gfV3ProductImageList({
      onImageClicked: function(imageUrl, imageZoomUrl) {}
  });

  var style = $module.attr('data-style');
  switch(style) {
      case 'slider':
          var navspeed = $module.data('navspeed'),
              navlg = $module.data('navlg'),
              navmd = $module.data('navmd'),
              navsm = $module.data('navsm'),
              navxs = $module.data('navxs'),
              collg = $module.data('collg'),
              colmd = $module.data('colmd'),
              colsm = $module.data('colsm'),
              colxs = $module.data('colxs'),
              dotslg = $module.data('dotslg'),
              dotsmd = $module.data('dotsmd'),
              dotssm = $module.data('dotssm'),
              dotsxs = $module.data('dotsxs'),

              marginlg = parseInt($module.data('mlg')),
              marginmd = parseInt($module.data('mmd')),
              marginsm = parseInt($module.data('msm')),
              marginxs = parseInt($module.data('mxs'));

          var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
          if(mode == 'production') {
              var loop = $module.data('loop');
          } else {
              var loop = 0;
          }
          $module.find('.gf_product-images-list').owlCarousel({
              mouseDrag: false,
              navSpeed: navspeed,
              autoWidth: !1,
              loop: loop,
              responsiveClass:true,
              responsive:{
                  0:{
                      items:colxs,
                      nav: navxs,
                      dots:dotsxs,
                      margin: marginxs
                  },
                  768:{
                      items:colsm,
                      nav: navsm,
                      dots:dotssm,
                      margin: marginsm
                  },
                  992:{
                      items:colmd,
                      nav: navmd,
                      dots:dotsmd,
                      margin: marginmd
                  },
                  1200:{
                      items:collg,
                      nav: navlg,
                      dots:dotslg,
                      margin: marginlg
                  }
              }
          }); 
          break;
  }
});jQuery(function() {
  var $module = jQuery('#m-1590679004128').children('.module');
});jQuery(function() {
  var $module = jQuery('#m-1590679053093').children('.module');
  $module.gfV3ProductDesc();
});jQuery(function() {
  try {
    var $module = jQuery('#m-1590679072539').children('.module');
    var single = $module.attr('data-single');
    var openDefault = $module.attr('data-openDefault');
    var openTab = $module.attr('data-openTab');
    var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';

    if(openDefault == 0 || openDefault == '0') {
      openTab = '0';
    }

    $module.gfAccordion({
      single: single,
      openTab: openTab,
      mode: mode,
      onChanged: function() {	
        // Fix (P) Desc read more bug	
        $module.find('.module-wrap[data-label="(P) Description"]').each(function(index, el) {	
          if (jQuery(el).children('.module').data('gfv3productdesc') != undefined) {	
            jQuery(el).children(".module").data("gfv3productdesc").initReadMore();	
          }	
        })	
      }
    });

    var borderColor = $module.attr('data-borderColor');
    var borderSize = $module.attr('data-borderSize');

    $module.children('[data-accordion]').children('[data-control]').css('border-bottom', borderSize + ' solid ' + borderColor);
    $module.children('[data-accordion]').children('[data-content]').children().css('border-bottom', borderSize + ' solid ' + borderColor);
  } catch(err) {}
});
var gemFlag=!1;for(var i=0;i<pageLibs.length;i++){if(pageLibs[i].indexOf('gfv3product.js')!==-1){if(jQuery.gfV3Product==undefined){gemFlag=!0;break}}if(pageLibs[i].indexOf('gfv3restabs.js')!==-1){if(jQuery.gfV3ResTabs==undefined){gemFlag=!0;break}}if(pageLibs[i].indexOf('gfaccordion.js')!==-1){if(jQuery.gfAccordion==undefined){gemFlag=!0;break}}}if(gemFlag){var count=0;for(var i=0;i<pageLibs.length-1;i++){jQuery.getScript(pageLibs[i],function(){count++;if(count==pageLibs.length-1){jQuery.getScript(pageLibs[pageLibs.length-1],function(){})}})}}